<template>
  <div>
    <modal-crear-editar :configuracion="configuracion_modal" @realizado="restablecer_inputs"></modal-crear-editar>
    <tablita :cols="columnas" @cargar="cargar($event)" @cargar_url="cargar_url($event)" @nuevo="crear"
      @editar="editar($event)" :configuracion="configuracion_tabla" @refresh="refrescar($event)"></tablita>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
import Tabla from "../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      {
        key: "nombre",
        label: "Nombre",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "nombre",
      },
      {
        key: "tramo_peaje_id",
        label: "Tramo",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "tramo_peaje_texto",
      },
    ],
    botones: [
      {
        label: "Editar",
        clase: "btn-warning",
        evento: "editar",
        icono: "fa fa-pen",
      },
    ],
    lista: [],
    links: [],
    inputs: [
      {
        cols: 6,
        tipo: "texto",
        key: "nombre",
        valor: "",
        label: "Nombre (*)",
        disabled: false,
      },
      {
        key: "tramo_peaje_id",
        label: "Tramo",
        busqueda: "",
        tipo: "select",
        searchable: true,
        opciones: [],
        valor_opcion: "id",
        label_opcion: "nombre",
      },
    ],
    configuracion_modal: {
      titulo: "Registrar Peaje",
      ancho: "xl",
      ruta: "/peaje",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Peajes",
      titulo_boton: "Crear Peaje",
      clase_boton: "btn-primary",
      btn_nuevo: true,
    },
    pagina_actual: "",
    /* columns: [
            {label: 'Rut', field: 'rut'},
            {label: 'Nombre', field: 'nombre', headerClass: 'class-in-header second-class'}
        ], */
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
      });
    }
    this.$emit("spinner", true);
    this.cargar_tramos()
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },

    async cargar_tramos($event) {
      this.$emit("spinner", true);
      await this.axios
        .get(`${this.api}/tramo_peaje?limit=999999`, this.cabeceras_json)
        .then((res) => {
          this.columnas[1].opciones = res.data.data.data;
          this.inputs[1].opciones = res.data.data.data;
          this.$emit("cargar");
        })
        .catch((e) => {
          //alert(e);
        });
      this.cargar('');
    },

    async cargar($event) {
      this.$emit("spinner", true);
      this.lista = [];
      this.pagina_actual = `${this.api}/peaje${$event}`;
      await this.axios
        .get(`${this.api}/peaje${$event}`, this.cabeceras_json)
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
          });
          this.$emit("generar", this.columnas, this.lista);
        })
        .catch((e) => {
          //alert(e);
        });
      this.$emit("spinner", false);
    },
    async cargar_url(url) {
      if (url) {
        this.$emit("spinner", true);
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
        this.$emit("spinner", false);
      }
    },
    crear() {
      this.setear_inputs(this.inputs);
      this.restablecer_inputs();
      this.configuracion_modal.ruta = `/peaje`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },
    editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            i.valor = valor;
          }
        });
      });
      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/peaje/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },
    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        i.valor = "";
      });
      this.setear_inputs(this.inputs);
    },
    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "cabeceras_json"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },
    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>